import {
    FETCH_SUMMARY_REQUEST,
    FETCH_SUMMARY_SUCCESS,
    FETCH_SUMMARY_FAILED,
    FETCH_SUMMARY_DETAIL_REQUEST,
    FETCH_SUMMARY_DETAIL_SUCCESS,
    FETCH_SUMMARY_DETAIL_FAILED,
    FETCH_AVAILABLE_INVOICE_REQUEST,
    FETCH_AVAILABLE_INVOICE_SUCCESS,
    FETCH_AVAILABLE_INVOICE_FAILED,
    DOWNLOAD_SIMPLE_EXCEL_REQUEST,
    DOWNLOAD_SIMPLE_EXCEL_SUCCESS,
    DOWNLOAD_SIMPLE_EXCEL_FAILED,
    DOWNLOAD_DETAIL_CSV_REQUEST,
    DOWNLOAD_DETAIL_CSV_SUCCESS,
    DOWNLOAD_DETAIL_CSV_FAILED,
    DOWNLOAD_INVOICE_PDF_REQUEST,
    DOWNLOAD_INVOICE_PDF_SUCCESS,
    DOWNLOAD_INVOICE_PDF_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_SUMMARY_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_SUMMARY_SUCCESS]: (state, { data, status }) => {
        state.status = status
        state.currentSummary = {
            cost: data && data.summary && data && data.summary.cost,
            date: data && data.summary && data && data.summary.date,
            increasedRate: data && data.summary && data && data.summary.increasedRate
        }
        state.estimatedSummary = {
            cost: data && data.summary && data && data.summary.estimatedCost,
            date: data && data.summary && data && data.summary.lastDateOfMonth,
            increasedRate: data && data.summary && data && data.summary.estimatedIncreasedRate
        }
        state.regions = (data && data.regions) || {}
        state.products = (data && data.products) || {}
        state.months = (data && data.months) || []
        state.weeks = (data && data.weeks) || []
        state.dates = (data && data.dates) || []
    },
    [FETCH_SUMMARY_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_SUMMARY_DETAIL_REQUEST]: state => {
        state.detail.status = 'loading'
    },
    [FETCH_SUMMARY_DETAIL_SUCCESS]: (state, { data, status }) => {
        state.detail.status = status
        state.detail.data = data
    },
    [FETCH_SUMMARY_DETAIL_FAILED]: (state, error) => {
        state.detail.status = 'error'
    },
    [FETCH_AVAILABLE_INVOICE_REQUEST]: state => {
        // state.status = 'loading'
    },
    [FETCH_AVAILABLE_INVOICE_SUCCESS]: (state, data) => {
        // state.status = 'success'
        state.hasInvoice = data.data
    },
    [FETCH_AVAILABLE_INVOICE_FAILED]: (state, error) => {
        // state.status = 'error'
    },
    [DOWNLOAD_SIMPLE_EXCEL_REQUEST]: state => {
        // state.staus = 'loading'
        state.downloadLoading.simpleExcel = true
    },
    [DOWNLOAD_SIMPLE_EXCEL_SUCCESS]: state => {
        // state.staus = 'success'
        state.downloadLoading.simpleExcel = false
    },
    [DOWNLOAD_SIMPLE_EXCEL_FAILED]: state => {
        // state.staus = 'error'
        state.downloadLoading.simpleExcel = false
    },
    [DOWNLOAD_DETAIL_CSV_REQUEST]: state => {
        // state.status = 'loading'
        state.downloadLoading.detailCSV = true
    },
    [DOWNLOAD_DETAIL_CSV_SUCCESS]: (state, data) => {
        // state.status = 'success'
        state.downloadLoading.detailCSV = false
    },
    [DOWNLOAD_DETAIL_CSV_FAILED]: (state, error) => {
        // state.status = 'error'
        state.downloadLoading.detailCSV = false
    },
    [DOWNLOAD_INVOICE_PDF_REQUEST]: state => {
        // state.status = 'loading'
        state.downloadLoading.invoicePDF = true
    },
    [DOWNLOAD_INVOICE_PDF_SUCCESS]: (state, data) => {
        // state.status = 'success'
        state.downloadLoading.invoicePDF = false
    },
    [DOWNLOAD_INVOICE_PDF_FAILED]: (state, error) => {
        // state.status = 'error'
        state.downloadLoading.invoicePDF = false
    }
}

export default mutations
